import { faWarning } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { useTranslation } from "react-i18next"

interface InvitedProfileWarningProps {}

const InvitedProfileWarning: React.FC<InvitedProfileWarningProps> = () => {
  const { t } = useTranslation()
  return (
    <div className="flex items-center space-x-2 mt-1">
      <FontAwesomeIcon className="text-gray-400" icon={faWarning} fontSize={"small"} />
      <p className="italic text-sm text-gray-500">{t("invitation.connectedWarningMessage")}</p>
    </div>
  )
}

export default InvitedProfileWarning
